<template>
    <section>
        <p>{{ text }}</p>

        <section class="checkBtns">
            <button @click="() => {this.verifyAll(true)}">{{ $t('checkAll') }}</button>
            <button @click="() => {this.verifyAll(false)}">{{ $t('uncheckAll') }}</button>
        </section>

        <section :class="viewStyle == 'list' ? 'inputList' : 'inputBlock'">
            <section v-for="(item, idx) in this.localData" :key="`${identifier}-${idx}`" class="inputComponent">
                <b-form-checkbox :id="`${idx}-${identifier}-check`" v-model="item.checked" :disabled="blockInput == true ? item.disable : false">
                    {{ item[dataKey] }}
                </b-form-checkbox>
            </section>
        </section>
    </section>
</template>

<script>
export default {
    name: "CustomCheckList",
    props: ["data", "dataKey", "text", "viewStyle", "identifier", "blockInput"],
    data(){
        return {
            localData:[]
        }
    },
    methods: {
        verifyAll(checkStatus){
            this.localData.forEach(item => {
                if(this.blockInput == true) item.checked = item.disable == false ? checkStatus : false;
                else item.checked = checkStatus;
            })
        },
    },

    mounted(){
        this.localData = [...this.data]
        this.verifyAll(false);
    }
}
</script>

<style scoped>
p{
    font-size: 1.1rem;
    font-weight: 600;
    padding: 0.3rem 0;
}

.checkBtns {
    display: flex;
    column-gap: 1rem;
    margin: 1rem 0;
}

.inputList, .inputBlock {
    max-height: 15rem;
    overflow-y: auto;
    margin-top: 1.3rem;
    margin-bottom: 0.5rem;
}

.inputComponent {
    padding: 0.5rem 0;
    font-size: 1.1rem;
}

.inputList .inputComponent{
    border-bottom: 1px solid #eeeeee;
}

.inputComponent:hover {
    background-color: #f7f7f7;
}

.inputComponent label {
    padding-left: 0.5rem;
}

.checkBtns button {
    padding: 0.1rem 1.2rem;
    border: 1px solid #FF7122;
    border-radius: 0.2rem;
    font-weight: 500;
    font-size: 1rem;
    color: #FF7122;
    background-color: #ffff;
}

.checkBtns button:first-child {
    color: #ffffff;
    background-color: #FF7122;
}

.inputBlock{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(4, 1fr);
    grid-auto-flow: column;
}
</style>